export const isLiveCreator = (creator) => creator?.source === "live";
export const isLiveVideo = (video) => typeof video?.url === "string" && video.url.trim().length > 0;

export default function LiveDemoBadge({ creator, video, originAvailable = true, testid, legacyLiveId }) {
  if (!originAvailable) return null;
  const live = creator ? isLiveCreator(creator) : isLiveVideo(video);
  return <span data-testid={testid || `${creator ? "creator" : "video"}-origin-${(creator || video)?.id}`} className={`inline-flex shrink-0 rounded-full px-2 py-0.5 text-[10px] font-semibold ${live ? "bg-emerald-500/15 text-emerald-700 dark:text-emerald-400" : "bg-muted text-muted-foreground"}`}><span data-testid={live ? legacyLiveId : undefined}>{live ? "Live" : "Demo"}</span></span>;
}
